import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
export const Card = ({ isDefault, isInactive = false, defaultLabel, children, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-testid": "card", className: `sui-w-full sui-h-full sui-p-4 sui-bg-primary sui-rounded-base sui-border-solid
        ${isDefault
                ? 'sui-border-2 sui-border-accent'
                : 'sui-border-1 sui-border-inactive'}` },
            isDefault && (React.createElement(Typography, { weight: "bold", color: isInactive ? 'inactive' : 'subtle' }, defaultLabel)),
            children)));
};
Card.displayName = 'Card';
